import { render, staticRenderFns } from "./DukakitLiquidityAdmin.vue?vue&type=template&id=eb1f52b0&scoped=true"
import script from "./DukakitLiquidityAdmin.vue?vue&type=script&lang=js"
export * from "./DukakitLiquidityAdmin.vue?vue&type=script&lang=js"
import style0 from "./DukakitLiquidityAdmin.vue?vue&type=style&index=0&id=eb1f52b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1f52b0",
  null
  
)

export default component.exports